export const ItemVacio = (idPadre) => {
  return {
    id: null,
    idTorneo: idPadre,
    pais: null,
  };
};

export const saveItem = (item) => {
  return {
    idTorneo: item.idTorneo,
    idPais: item.pais && item.pais.id,
  };
};
